var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picker',{attrs:{"range":_vm.options,"value":_vm.value,"title":_vm.title},on:{"change":_vm.handleChange}},[_vm._v(_vm._s(_vm.value || _vm.placeholder))])
}
var staticRenderFns = []

export { render, staticRenderFns }